import './App.css';
import * as React from 'react'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import MyNavbar from './pages/navbar';
import Footer from './pages/footer';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <MyNavbar />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
